import React, { FC } from 'react';

import { Table } from './components/Table';

export const Slot: FC = () => {
  return (
    <>
        <h3>Паттерн "Слот"</h3>
        <p>
          Паттерн "Слот" в React позволяет создавать гибкие и переиспользуемые компоненты с определенными "слотами" для контента. 
          Преимущества: улучшенная композиция компонентов, четкая структура, возможность переопределения частей компонента.
          Недостатки: может усложнить код при неправильном использовании, требует дополнительного планирования структуры компонентов.
        </p>
        <div><Table /></div>
    </>
  )
};
